import { Button } from "@headlessui/react";
import { useFirebase } from "../FbContex";

export default function ForbidenArea() {
  const { signOut } = useFirebase();

  return (
    <div className="flex flex-col justify-center items-center h-screen">
      <h1>access denied</h1>
      {/* <h3>Restricted area, you're not allowed to </h3> */}

      <div className="mt-4">
        <Button
          onClick={signOut}
          className="text-center w-48 gap-2 rounded-md bg-red-700 py-1.5 px-3 text-sm/6 font-semibold text-white shadow-inner shadow-white/10 focus:outline-none data-[hover]:bg-red-600 data-[open]:bg-red-700 data-[focus]:outline-1 data-[focus]:outline-white"
        >
          Logout
        </Button>
      </div>
    </div>
  );
}
